module.exports = __webpack_public_path__ + "media/67.ae40d0aa.mp3";